<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="headTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainTitle"></div>
          <el-tabs class="elTabs" v-model="activeName" @tab-click="handleClick" v-if="initDatas">
            <el-tab-pane label="积分管理" name="0">
              <AlumniList></AlumniList>
            </el-tab-pane>
            <el-tab-pane label="商品管理" name="1">
              <ProductList></ProductList>
            </el-tab-pane>
            <el-tab-pane label="订单管理" name="2">
              <OrderList></OrderList>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import AlumniList from '@/components/integral/alumniList'
import ProductList from '@/components/integral/productList'
import OrderList from '@/components/integral/orderList'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    AlumniList,
    ProductList,
    OrderList
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      headTitle: '',
      activeName: '0',
      initDatas: false
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.headTitle = this.$route.query.title
      this.initDatas = true
    },
    handleClick(tab, event) {}
  }
}
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -40px;
  margin-left: -20px;
  margin-right: -20px;
}
.elTabs {
  margin-top: -40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/integral.vue